import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Divider, Tooltip } from "antd";
import { getApplicationConfigsAsync } from "../../store/reducers/appCommonSlice";
import pkgjson from '../../../package.json'

const ListAppComp = () =>
{
  const dispatch = useDispatch();

  const [dataSetting, setDataSetting] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const visibleListApp = useSelector(
    (state: RootState) => state.appCommonSlice.visibleListApp
  );
  const getData = async () =>
  {
    // @ts-ignore
    let res = await dispatch(getApplicationConfigsAsync()).unwrap();
    setData(res?.data?.modules ?? []);
    setDataSetting(res?.data ?? {});
  };
  useEffect(() =>
  {
    if (visibleListApp)
    {
      getData();
    }
  }, [visibleListApp]);

  return (
    <div
      className="absolute list-app"
      style={{ display: visibleListApp ? "block" : "none" }}
    >
      <div
        className="grid gap-4"
        style={{
          gridTemplateColumns: `repeat(${dataSetting?.cols}, minmax(0, 1fr))`,
        }}
      >
        {data?.map((item: any, ind: any) => (
          <div
            onClick={() => window.open(item?.href, item?.target)}
            key={ind}
            className="flex text-center items-center flex-col hover:bg-[var(--primary-5)] rounded-md !cursor-pointer h-[110px] w-[110px] px-1 py-2"
          >
            <div className="bg-[#D9D9D9] !min-h-12 h-12 w-12 rounded-full flex justify-between items-center flex-col">
              <img
                src={
                  item?.icon?.type === "static"
                    ? `${item?.icon?.name}`
                    : item?.icon?.name
                }
              />
            </div>
            <Tooltip title={item?.label?.[dataSetting?.locale]}>
              <p style={{ fontSize: "12px" }} className="mt-[12px]">
                {item?.label?.[dataSetting?.locale]}
                {/* {item?.label?.[dataSetting?.locale]?.length > 12
                  ? item?.label?.[dataSetting?.locale]?.slice(0, 7) + "..."
                  : item?.label?.[dataSetting?.locale]} */}
              </p>
            </Tooltip>
          </div>
        ))}
      </div>

      <Divider />
      <p>Version: {pkgjson?.version}</p>
    </div>
  );
};

export default ListAppComp;
